import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=a19119e2&"
import script from "./approver.vue?vue&type=script&lang=js&"
export * from "./approver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports